import Vue from 'vue'
import Vuex from 'vuex'
import Modules from './modules'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        ...Modules
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js